// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3XV0p","detailsBorder":"styles_detailsBorder__JoV4G"};